import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e87e05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 알림 ")

import {AgBoxS, AgContentS, AgIconS} from '@/components/ag'
import {IonPage} from '@ionic/vue'
import {gql} from 'graphql-tag'
import {useRouter} from 'vue-router'
import SettingItem from './SettingItem.vue'
import {watch, reactive, ref} from 'vue'
import {useMutation} from '@vue/apollo-composable'
import {debounce} from 'lodash'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const agreeCheck = reactive({
  deal: false,
  marketing: false,
  point: false,
})

const agreeNotificationAbort= ref<undefined | AbortController>()

const {mutate: agreeNotification} = useMutation(gql`
      mutation {
        agreeUserAppPush
      }
    `)

const router = useRouter()

const onBack = () => {
  router.push('/settings')
}

const setAgreeNotification = () => {
  const abortController = new AbortController()
  agreeNotification({}, {
    context: {
      fetchOptions: {
        signal: abortController.signal,
      },
    },
  })
  agreeNotificationAbort.value = abortController
}

watch(agreeCheck, debounce((value) => {
  console.log(value)
  agreeNotificationAbort.value?.abort()
  setAgreeNotification()
}, 750))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), {
        css: {height: 67, width: '100%', pt: 'safeAreaTop', dp: 'flex', alignItems: 'center', px: 20, bg: 'white'},
        onClick: onBack
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgIconS), {
            name: "chevronBack",
            css: {width: 24, height: 24, mr: 16}
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h5'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgContentS), { css: {bg: 'white'} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            css: {px: 20},
            class: "setting-list"
          }, {
            default: _withCtx(() => [
              _createVNode(SettingItem, {
                modelValue: _unref(agreeCheck).deal,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(agreeCheck).deal) = $event)),
                title: "판매 / 열기 / 협의",
                description: "판매, 열기, 협의 관련 진행 현황을 실시간으로 알려드립니다. 판매, 열기, 협의를 위해 필수 기능힙니다"
              }, null, 8, ["modelValue"]),
              _createVNode(SettingItem, {
                modelValue: _unref(agreeCheck).point,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(agreeCheck).point) = $event)),
                title: "포인트, 클럽딜 참여",
                description: "포인트 적립, 포인트 사용, 클럽딜 참여, 입금, 조합설립 관련 현황을 실시간으로 알려드립니다"
              }, null, 8, ["modelValue"]),
              _createVNode(SettingItem, {
                modelValue: _unref(agreeCheck).marketing,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(agreeCheck).marketing) = $event)),
                title: "마케팅 정보 수신",
                description: "조합, 회사 정보 받으시려면 동의해주세요.(선택)"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})